function cov_2hvthg5jk2() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx";
  var hash = "e7cc4efcf932e0be8f30eddefe086b5019605309";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 57
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "1": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 120,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 57
          },
          end: {
            line: 21,
            column: 58
          }
        },
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 121,
            column: 1
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 11
          },
          end: {
            line: 54,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 11
          },
          end: {
            line: 50,
            column: 16
          }
        }, {
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 53,
            column: 19
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 59,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 55,
            column: 34
          }
        }, {
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 58,
            column: 19
          }
        }],
        line: 55
      },
      "2": {
        loc: {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 72,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 61,
            column: 24
          }
        }, {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 71,
            column: 16
          }
        }],
        line: 61
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 27
          },
          end: {
            line: 64,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 27
          },
          end: {
            line: 64,
            column: 37
          }
        }, {
          start: {
            line: 64,
            column: 41
          },
          end: {
            line: 64,
            column: 46
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 77,
            column: 13
          },
          end: {
            line: 77,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 13
          },
          end: {
            line: 77,
            column: 17
          }
        }, {
          start: {
            line: 77,
            column: 21
          },
          end: {
            line: 77,
            column: 34
          }
        }],
        line: 77
      },
      "5": {
        loc: {
          start: {
            line: 79,
            column: 11
          },
          end: {
            line: 88,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 11
          },
          end: {
            line: 79,
            column: 16
          }
        }, {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 87,
            column: 15
          }
        }],
        line: 79
      },
      "6": {
        loc: {
          start: {
            line: 89,
            column: 11
          },
          end: {
            line: 98,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 11
          },
          end: {
            line: 89,
            column: 15
          }
        }, {
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 97,
            column: 15
          }
        }],
        line: 89
      },
      "7": {
        loc: {
          start: {
            line: 99,
            column: 11
          },
          end: {
            line: 108,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 11
          },
          end: {
            line: 99,
            column: 23
          }
        }, {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 107,
            column: 15
          }
        }],
        line: 99
      },
      "8": {
        loc: {
          start: {
            line: 112,
            column: 13
          },
          end: {
            line: 112,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 13
          },
          end: {
            line: 112,
            column: 25
          }
        }, {
          start: {
            line: 112,
            column: 29
          },
          end: {
            line: 112,
            column: 48
          }
        }],
        line: 112
      },
      "9": {
        loc: {
          start: {
            line: 115,
            column: 13
          },
          end: {
            line: 115,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 13
          },
          end: {
            line: 115,
            column: 17
          }
        }, {
          start: {
            line: 115,
            column: 21
          },
          end: {
            line: 115,
            column: 30
          }
        }],
        line: 115
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e7cc4efcf932e0be8f30eddefe086b5019605309"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hvthg5jk2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hvthg5jk2();
import React from 'react';
import { Box, FavoriteButton, Image, Link, Text } from '@opendoor/bricks-next';
import { formatCurrency } from '@opendoor/bricks/helpers/currencyHelpers';
cov_2hvthg5jk2().s[0]++;
export var PropertyCard = function PropertyCard(_ref) {
  var _ref2;
  var beds = _ref.beds,
    baths = _ref.baths,
    city = _ref.city,
    dwellingType = _ref.dwellingType,
    estimatedMonthlyPayment = _ref.estimatedMonthlyPayment,
    href = _ref.href,
    isFavorite = _ref.isFavorite,
    neighborhood = _ref.neighborhood,
    onFavoritePress = _ref.onFavoritePress,
    photoUrl = _ref.photoUrl,
    price = _ref.price,
    sqft = _ref.sqft;
  cov_2hvthg5jk2().f[0]++;
  cov_2hvthg5jk2().s[1]++;
  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    analyticsName: "marketplace-property-card-image-link"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    mb: "$8x",
    borderRadius: "$8x",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Main view of property",
    borderRadius: "$8x",
    source: {
      uri: photoUrl
    },
    resizeMode: "cover",
    aspectRatio: 16 / 9
  }))), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 8
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "baseline"
  }, (cov_2hvthg5jk2().b[0][0]++, price) && (cov_2hvthg5jk2().b[0][1]++, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: "$contentPrimary",
    typography: "$labelXlarge",
    mr: 4
  }, formatCurrency(price))), (cov_2hvthg5jk2().b[1][0]++, estimatedMonthlyPayment) && (cov_2hvthg5jk2().b[1][1]++, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: "$contentTertiary",
    typography: "$bodySmall",
    ml: 4
  }, formatCurrency(estimatedMonthlyPayment), "/month est."))), (cov_2hvthg5jk2().b[2][0]++, onFavoritePress) && (cov_2hvthg5jk2().b[2][1]++, /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(FavoriteButton, {
    isFavorited: (_ref2 = (cov_2hvthg5jk2().b[3][0]++, isFavorite)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2hvthg5jk2().b[3][1]++, false),
    analyticsName: "marketplace-property-card-favorite-button",
    onPress: onFavoritePress,
    size: "small",
    variant: "default",
    alignSelf: "center"
  })))), /*#__PURE__*/React.createElement(Link, {
    href: href,
    analyticsName: "marketplace-property-card-info-link"
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "baseline",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentTertiary"
  }, (cov_2hvthg5jk2().b[4][0]++, beds) && (cov_2hvthg5jk2().b[4][1]++, "".concat(beds, " bds"))), (cov_2hvthg5jk2().b[5][0]++, baths) && (cov_2hvthg5jk2().b[5][1]++, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentStateInactiveSecondary"
  }, ' • '), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentTertiary"
  }, "".concat(baths, " ba")))), (cov_2hvthg5jk2().b[6][0]++, sqft) && (cov_2hvthg5jk2().b[6][1]++, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentStateInactiveSecondary"
  }, ' • '), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentTertiary"
  }, "".concat(sqft.toLocaleString(), " sqft")))), (cov_2hvthg5jk2().b[7][0]++, dwellingType) && (cov_2hvthg5jk2().b[7][1]++, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentStateInactiveSecondary"
  }, ' • '), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall",
    color: "$contentTertiary"
  }, dwellingType)))), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "baseline"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    mr: "$1x",
    typography: "$bodySmall",
    color: "$contentTertiary"
  }, (cov_2hvthg5jk2().b[8][0]++, neighborhood) && (cov_2hvthg5jk2().b[8][1]++, "".concat(neighborhood, ", "))), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    mr: "$1x",
    typography: "$bodySmall",
    color: "$contentTertiary"
  }, (cov_2hvthg5jk2().b[9][0]++, city) && (cov_2hvthg5jk2().b[9][1]++, "".concat(city))))));
};
//# sourceMappingURL=PropertyCard.mjs.map